function AccodionCtrl(scope) {
    const vm = this;
    vm.closeAll = function () {
      scope.closeAccordion();
    };
}

module.exports = function () {
    return {
        restrict: 'AE',
        scope: {
          closeOthers: '@?'
        },
        controller: ['$scope', AccodionCtrl],
        controllerAs: 'vm',
        link(scope, element) {
          scope.closeOthers = scope.closeOthers || true;
          scope.closeAccordion = function () {
            if (scope.closeOthers) {
              element.find('[bws-accordion-body]').slideUp('fast');
              element.find('.open').toggleClass('open');
            }
          };
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/accordion/accordion.js
 **/